import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getFullName } from 'utilities/person'
import { ParagraphSmall } from 'components/typography/paragraph'

const DocumentSigningStatusDetails = ({ signatories, status }) => {
    if(!signatories?.length) {
        return null
    }

    const count = signatories.filter(({ signedAt }) => !!signedAt).length
    const total = signatories.length
    const rejecter = signatories.find(({ rejectedAt }) => !!rejectedAt)?.user

    return (
        <>
            {['pending', 'closed'].includes(status) && (
                <>
                    <span>·</span>
                    <ParagraphSmall className="compact">
                        <FormattedMessage
                            id="document_signing_count_of_total_signed"
                            defaultMessage="{count, plural, =0 {{count} of {total} have signed} =1 {{count} of {total} has signed} other {{count} of {total} have signed}}"
                            values={{ count, total }} />
                    </ParagraphSmall>
                </>
            )}
            {((status === 'rejected') && !!rejecter) && (
                <>
                    <span>·</span>
                    <ParagraphSmall className="compact">
                        <FormattedMessage
                            id="byline"
                            defaultMessage="By {name}"
                            values={{ name: getFullName(rejecter, { fallback: false }) }} />
                    </ParagraphSmall>
                </>
            )}
        </>
    )
}

export default DocumentSigningStatusDetails